
export default function GeozoneDetailsEventController($scope, $stateParams, GeozoneService) {

    'ngInject';
    
    var refresh = function () {
        GeozoneService.getGeozoneById($stateParams.geozoneId).then(function (response) {
            $scope.alertConfig = response.data.alertRule;
            $scope.loading = false;

        }, function () {

        });
    };

    refresh();
}
